import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { allMyApplicationsQueryOptions } from "@/features/applications/queries";
import { allMyBookmarksQueryOptions } from "@/features/bookmarks/queries";
import { SavedCasesPage } from "@/features/bookmarks/saved-cases-page";
import { STATIC_LABELS } from "@/lib/nav-registry";

// 全件取得してクライアント側で企業グルーピング / 保存日ソート / 絞り込みを行う。
// URL で保持する UI 状態: 自由検索 (q)・企業選択 (companies)・応募状況 (statuses)・保存日の並び順 (order)。
const searchSchema = z.object({
  /** 自由検索（企業名・案件名・案件概要を横断、部分一致）。 */
  q: z.string().optional(),
  /** 企業選択。カンマ区切りの企業名。 */
  companies: z.string().optional(),
  /** 応募状況の絞り込み。カンマ区切り（未応募 + 応募ステータス）。 */
  statuses: z.string().optional(),
  /** 保存日の並び順。既定は新しい順。 */
  order: z.enum(["asc", "desc"]).default("desc"),
});

// ロールガードは親 layout (`member/route.tsx`) が MEMBER 限定。
export const Route = createFileRoute("/_authenticated/member/saved")({
  staticData: { crumb: { label: STATIC_LABELS.memberSaved } },
  validateSearch: searchSchema,
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(allMyBookmarksQueryOptions()),
      context.queryClient.ensureQueryData(allMyApplicationsQueryOptions()),
    ]);
  },
  component: SavedCasesPage,
});
